import { useCallback, useEffect, useState } from "react";

const KEY = "ecoroute-journal";
const MAX = 20;

const read = () => {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
};

export const useJournal = () => {
  const [routes, setRoutes] = useState(read);

  useEffect(() => {
    try {
      localStorage.setItem(KEY, JSON.stringify(routes));
    } catch {}
  }, [routes]);

  const save = useCallback(
    (route) => {
      if (!route || routes.some((r) => r.id === route.id)) return false;
      setRoutes([{ ...route, savedAt: new Date().toISOString() }, ...routes].slice(0, MAX));
      return true;
    },
    [routes],
  );

  const remove = useCallback((id) => {
    setRoutes((prev) => prev.filter((r) => r.id !== id));
  }, []);

  const hasRoute = useCallback((id) => routes.some((r) => r.id === id), [routes]);

  return { routes, save, remove, hasRoute };
};
